export default class UnreachableCaseError extends Error {
  message = "Unexpectedly encountered an unreachable case";
}
